import React from "react";

import { getText } from "../../helpers";

const LabeledText = (props) => {
  const { label, text, separator = ":" } = props;
  const className = props.className ? `labeled-text ${props.className}` : "labeled-text";
  return (
    <span className={className}>
      <label>{label}</label>
      <span className="separator">{separator}</span>
      <span className="text">{text}</span>
    </span>
  );
};

export default function ActivityDescription(props) {
  const { workPhase, activity } = props;
  const className = props.className ? `activity-description ${props.className}` : "activity-description";
  return (
    <div className={className}>
      <LabeledText label={getText("Work Phase or Ambient Exposure")} text={workPhase} />
      <span className="activity-description-separator">|</span>
      <LabeledText label={getText("Activity")} text={activity} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/create_inspection_link/activity_description.js